export default __webpack_public_path__ + "static/media/Skin_Banner.955b0de2.jpg";